import PageCollection from '../../base/collections/page';

import { Contact } from '../models/contact';

export const ContactCollection = PageCollection.extend({
  model: Contact
});



// WEBPACK FOOTER //
// ./epayment/collections/contact.js